<template>
  <div>
<!--    <el-radio-group v-model="sortId" class="ml-4" style="margin-bottom: 16px;">-->
<!--      <el-radio v-for="item in sortIdList" :key="item.id" :label="item.id" size="large">{{ item.sort }}</el-radio>-->
<!--    </el-radio-group>-->
    <div style="margin-bottom: 16px;">
      <label>分类：</label>
      <el-select v-model="sortId" placeholder="Select" style="width: 12em">
        <el-option v-for="item in sortIdList" :key="item.id" :label="item.sort" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="dialog-footer" style="text-align: left">
      <el-button @click.native="cancel" >返回</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {updateLoveSubmitState, getLoveSubmitSortList} from '../../../api/url'
import {postFormData, getFormData} from "@/api/api";

export default {
  name: "ReportDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      loading: false,
      sortIdList: [{ sort: '不做分类', id: 0 }],
      sortId: 0
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['idArr'] = this.idArray;
      param['sortId'] = this.sortId;
      param['state'] = 1;
      postFormData(updateLoveSubmitState, param).then((data)=>{
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        }else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    getSortList() {
      this.sortIdList = [{ sort: '不做分类', id: 0 }];
      let _this = this;
      getFormData(getLoveSubmitSortList, {}).then((data) => {
        let { code, msg } = data;
        if(code == 200) {
          _this.sortIdList = _this.sortIdList.concat(data.data);
        }
      })
    }

  },
  created() {
    this.getSortList();
  }
}
</script>

<style scoped>

</style>
